// extracted by mini-css-extract-plugin
export var messageSideLeft = "_me-1";
export var messageSideRight = "_me-2";
export var subscribeToBackInStockBubbleContainer = "_me-0";